import { z } from "zod";
import { ServerChatMessage } from "@/components/common/section-components/chat/chat-message.types";

export interface FutureContractEntity {
  id: number;
  fechaCreacion: string;
  titular: string;
  monto: number;
  tipoFijacion: string;
  toneladas: number;
  precioFinal: number;
  estadoDescripcion: string;
  grano: string;
  sinBase: boolean;
  tipoMoneda: string;
}

export interface FutureContractListResponse {
  pendingRequests: boolean;
  totalPages: number;
  totalRecords: number;
  listado: FutureContractEntity[];
}

export interface FutureContractDetail {
  id: number;
  idMovimientoBIND: string;
  montoSolicitado: number;
  saldoActual: number;
  control: boolean;
  fechaSolicitud: string;
  cuentaOrigen: number;
  sucursal: string;
  solicitante: string;
  estado: string;
  mensajes: ServerChatMessage[];
  titular: string;
  esCanje: boolean;
  grano: string;
  cosecha: string;
  toneladas: number;
  precioFinal?: number
  tipoMoneda: string;
  entrega: string;
  sinBase: boolean;
  mensajesDisponibles?: number;
}

export const futureContractSchema = z.object({
  account: z.any().optional(),
  grain: z.any().optional(),
  harvest: z.any().optional(),
  ton: z.any().optional(),
  price: z.any().optional(),
  delivery_month: z.any().optional(),
  isExchange: z.boolean().optional().nullish(),
  contract_detail: z.any().optional(),
  currency_type: z.any().optional(),
  available_ton: z.any().optional(),
});
